import {SourceWithSourceQuestions} from "../../../../../swaggerServices";
import {Instruction} from "./instruction";
import {Block, BlockType} from "./block";

export const literalSource: SourceWithSourceQuestions = {
  id: -1,
  name: "Literal",
  sourceQuestions: [],
};
export const calculationSource: SourceWithSourceQuestions = {
  id: -2,
  name: "Calculation",
  sourceQuestions: [],
};
export const startBlock: Block = {id: "start", name: "Start", description: "", documentation: {}, type: BlockType.Start};
export const startInstruction = new Instruction(-1, "Start", startBlock, [] );

let idAllocator = -1;

const placeholderBlock: Block = {id: "placeholder", name: "", description: "", documentation: {}, type: BlockType.Placeholder};
export const makePlaceholderInstruction = () => {
  idAllocator -= 1;
  return new Instruction(idAllocator, "", placeholderBlock, []);
};
